import service from '@/store/services/team-service';

const state = {
    list: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params);
    },

    remove({ commit, dispatch }, params) {
        return service.remove(params);
    },

    add({ commit, dispatch }, params) {
        return service.add(params);
    },

    edit({ commit, dispatch }, params) {
        return service.edit(params);
    },
    reinstate({ commit, dispatch }, params) {
        return service.reinstate(params);
    },
};

const getters = {
    list: (state) => state.list,
};

const team = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

export default team;